import './forms.css'
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { FormGroup, Row, Col } from 'react-bootstrap'
import { createTextMask } from 'redux-form-input-masks'
import Button from 'elements/CustomButton/CustomButton.jsx'
import { renderField, renderSelect } from './_fieldRenderer'

class PartnerForm extends React.Component {
    render() {
        const { handleSubmit, initialValues, submitting, states, discounts } = this.props

        const cnpjMask = createTextMask({
            pattern: '99.999.999/9999-99',
            guide: false
        });

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='companyName'
                                type='text'
                                component={renderField}
                                label='Razão Social'
                                placeholder='Razão Social'
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='tradingName'
                                type='text'
                                component={renderField}
                                label='Nome Fantasia'
                                placeholder='Nome Fantasia'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='cnpj'
                                type='text'
                                component={renderField}
                                label='CNPJ'
                                placeholder='00.000.000/0000-00'
                                {...cnpjMask}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='address'
                                type='text'
                                component={renderField}
                                label='Endereço'
                                placeholder='Endereço'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='district'
                                type='text'
                                component={renderField}
                                label='Bairro'
                                placeholder='Bairro'
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='city'
                                type='text'
                                component={renderField}
                                label='Cidade'
                                placeholder='Cidade'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='state'
                                component={renderSelect}
                                options={states}
                                label='Estado'
                                placeholder='Selecione'
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='discount'
                                component={renderSelect}
                                options={discounts}
                                label='Desconto'
                                placeholder='Selecione'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <p className='form__subheader'>Dados de acesso</p>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='email'
                                type='email'
                                component={renderField}
                                label='Email'
                                placeholder='Email'
                            />
                        </FormGroup>
                    </Col>
                    {!initialValues && (
                        <Col md={6}>
                            <FormGroup>
                                <Field
                                    name='password'
                                    type='password'
                                    component={renderField}
                                    label='Senha'
                                    placeholder='Min. 8 caracteres'
                                />
                            </FormGroup>
                        </Col>
                    )}
                </Row>

                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='danger'
                            type='button'
                            disabled={submitting}
                            onClick={this._handleCancel}
                            wd
                        >
                            Cancelar
                         </Button>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='default'
                            type='submit'
                            disabled={submitting}
                            fill
                        >
                            Salvar
                         </Button>
                    </Col>
                </Row>
            </form >
        )
    }

    _handleCancel = () => {
        this.props.reset() //form reset - redux-form action creator
        this.props.handleCancel() //function passed via props
    }
}

const validate = values => {
    const errors = {}
    if (!values.companyName) { errors.companyName = 'Obrigatório' }
    if (!values.tradingName) { errors.tradingName = 'Obrigatório' }
    if (!values.cnpj) { errors.cnpj = 'Obrigatório' }
    else if (values.cnpj.length < 14) { errors.cnpj = 'CNPJ incompleto' }
    if (!values.address) { errors.address = 'Obrigatório' }
    if (!values.district) { errors.district = 'Obrigatório' }
    if (!values.discount) { errors.discount = 'Obrigatório' }
    if (!values.city) { errors.city = 'Obrigatório' }
    if (!values.state) { errors.state = 'Obrigatório' }
    if (!values.email) { errors.email = 'Obrigatório' }
    if (!values.password) { errors.password = 'Obrigatório' }
    else if (values.password.length < 8) { errors.password = 'Min. 8 caracteres' }

    return errors
}

PartnerForm = reduxForm({ form: 'PartnerForm', validate })(PartnerForm)
export default PartnerForm



// WEBPACK FOOTER //
// ./src/forms/PartnerForm.jsx